<template>
    <div class="compont-left">
        <dl>
            <dt>

                <img v-if="userData.avatar" @click="showTipsModel" :src="userData.avatar" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <!-- <el-upload 
                    class="avatar-uploader" 
                    ref='upload11'
                    :http-request="httpRequest" 
                    action='actionUrl' 
                    style='display:none'>
                </el-upload> -->
            </dt>
        </dl>
        <ul>
            <li class="nav-notice" :class="{'active': $route.meta.active === 'studentsNote'}">
                <img src="../../assets/images/icon_note.png" alt="">
                <router-link to='/studentsNote'>学员须知</router-link>
            </li>
            <li class="nav-dynamic" :class="{'active': $route.meta.active === 'myInfo'}">
                <img src="../../assets/images/icon_my.png" alt="">
                <router-link to='/myInfo'>我的信息</router-link>
            </li>
            <li class="nav-study" :class="{'active': $route.meta.active === 'signStudy'}">
                <img src="../../assets/images/icon_sign.png" alt="">
                <router-link to='/signStudy'>专业选课</router-link>
            </li>
            <li class="nav-class" :class="{'active': $route.meta.active === 'myCourse'}">
                <img src="../../assets/images/icon_class.png" alt="">
                <router-link to='/myCourse'>专业学习</router-link>
            </li>
             <li class="nav-class" :class="{'active': $route.meta.active === 'publicSignStudy'}">
                <img src="../../assets/images/public_course1.png" alt="">
                <router-link to='/publicSignStudy'>公需选课</router-link>
            </li>
             <li class="nav-class" :class="{'active': $route.meta.active === 'publicCourse'}">
                <img src="../../assets/images/public_course.png" alt="">
                <router-link to='/publicCourse'>公需学习</router-link>
            </li>
            
            <li class="nav-class" :class="{'active': $route.meta.active === 'myCourseCopy'}">
                <img src="../../assets/images/icon_edu.png" alt="">
                <router-link to='/myCourseCopy'>补学教育</router-link>
            </li>
            <li class="nav-his" :class="{'active': $route.meta.active === 'exam'}">
                <img src="../../assets/images/icon_dry_run.png" alt="">
                <router-link to='/examList'>课后练习</router-link>
            </li>
            <li class="nav-myinfo" :class="{'active': $route.meta.active === 'myOrder'}">
                <img src="../../assets/images/icon_order.png" alt="">
                <router-link to='/myOrder'>我的订单</router-link>
            </li>
            <li class="nav-agreement" :class="{'active': $route.meta.active === 'agreement'}">
                <img src="../../assets/images/agree.png" alt="">
                <router-link to='/agreement'>服务协议</router-link>
            </li>
            <li class="nav-assessment" :class="{'active': $route.meta.active === 'assessment'}">
                <img src="../../assets/images/applet.png" alt="">
                <router-link to='/assessment'>药师考核</router-link>
            </li>
            <li class="nav-myinfo">
                <img src="../../assets/images/icon_home.png" alt="">
                <router-link to='/'>回到首页</router-link>
            </li>
        </ul>

        <el-dialog center title='提示' :visible.sync="isUpload" class="pulbicConfirm" width="305px"
            :show-close='false'>
            <div class="content" >更换人脸头像会导致无法继续学习，等待审核通过后方能学习</div>
            <el-row class="footer-but">
                <el-col :span="12">
                    <div class="grid-content bg-purple-dark cancel" @click="isUpload=false">取消</div>
                </el-col>
                <el-col :span="12">
                    <div class="grid-content bg-purple-dark sure" @click="uploadTrue">确定</div>
                </el-col>
            </el-row>
        </el-dialog>

        <!-- <common-confirm @sureOpen='sureOpen'></common-confirm> -->
    </div>
</template>
<script>
import { mapState } from 'vuex';
import commonConfirm from "./confirm.vue";
export default {
    name: 'leftMenu',
    computed: {
        ...mapState({
            userData: state => state.user.userData
        })
    },
    components: {
        commonConfirm,
    },
    data () {
        return {
            isUpload:false
            // imageUrl: 'http://img.baitongshiji.com/data/upload/hySep/5b9615564ec1c.png'
        }
    },
    mounted () {
        this.getUserInfo();
    },
    methods: {
        /**
         * 获取用户信息
         */
        getUserInfo () {
            this.$store.dispatch('userinfo', {}).then((res) => {
                console.log(res)
            })
        },
        //本地上传
        // httpRequest (options) {
        //     let file = options.file
        //     let filename = options.filename
        //     let reader = null;
        //     if (file) {
        //         reader = new FileReader()
        //         reader.readAsDataURL(file)
        //     }
        //     reader.onload = () => {
        //         this.fileUpload(reader.result);
        //     }
        // },

        /**
         * 点击头像
         */
        showTipsModel () {
            this.isUpload = true;
            // let target = {
            //     public_model_show: true,
            //     public_model_text: '更换人脸头像会导致无法继续学习，等待审核通过后方能学习',
            //     public_model_param: {}
            // }
            // this.$store.commit("show_public_model", target);
        },
        // fileUpload(result){
        //     this.$store.dispatch('avatar', { avatar: result }).then((res) => {
        //         if (res.code) {
        //             this.$message({
        //                 message: '上传成功',
        //                 type: 'success'
        //             });
        //             setTimeout(()=>{
        //                 localStorage.setItem('isLogin',true);
        //                 this.$store.commit('setLogin',true);
        //                 this.$router.push('/studentsNote');
        //             },1000)
        //         }
        //     })
        // },
        /**
         *
         */
        uploadTrue () {
            this.$router.push('/faceCollection')
            // document.getElementsByClassName('el-upload__input')[0].click();
            // console.log(123);
            // document.
            // this.$refs.upload.$children[0].post();
            // console.log(this.$refs)
            // console.log(this.$refs.upload)
            // this.$refs.upload11.submit();
            // this.$refs.upload.submit();
        }

    }
}
</script>
<style lang="stylus" scoped>
.compont-left
    padding-top 53px
    dl
        text-align center
        margin-bottom 20px
        dt
            height 108px
            img
                width 108px
                height 108px
                margin auto
        dd
            color #666
            padding 0 20px
            font-size 14px
    ul
        border-top 1px solid #F0F0F0
        li
            color #3D3430
            border-bottom 1px solid #F0F0F0
            padding 20px 0 18px
            text-align center
            img
                width 26px
                vertical-align middle
                margin-top -2px
                margin-right 10px
            a
                vertical-align middle
        li.active,li.active:hover
            background-image url('../../assets/images/menu_border.png')
            background-repeat no-repeat
            background-size 8px 100%
        li:hover 
            background #f4f8fc
// .router-link-active
// background red
.avatar-uploader
    height 108px
.avatar-uploader .el-upload
    border 1px dashed #d9d9d9
    border-radius 6px
    cursor pointer
    position relative
    overflow hidden
.avatar-uploader .el-upload:hover
    border-color #409EFF
.avatar-uploader-icon
    font-size 28px
    color #8c939d
    width 178px
    height 178px
    line-height 178px
    text-align center
.avatar
    display block
</style>
<style lang="stylus">
.el-upload-list.el-upload-list--text
    display none
</style>


// WEBPACK FOOTER //
// src/components/common/leftMenu.vue